import { OrganizationMemberDetailsComponent } from './organization-member-details.component';
import { Route } from '@angular/router';
import { UserChangeSetTransformer } from '@markant-platform/shared/audit/configuration';
import { OrganizationMemberHistoryResolver } from '@markant-platform/shared/organization/resolver';

export const OrganizationMemberDetailsRouting: Route[] = [
  {
    path: '',
    component: OrganizationMemberDetailsComponent,
  },
  {
    path: 'group-assignment',
    data: {
      translationKey: 'userGroupAssignment',
    },
    loadChildren: () =>
      import('@markant-platform/dashboard/feature-dashboard-group-assignment').then(
        m => m.DashboardFeatureDashboardGroupAssignmentModule
      ),
  },
  {
    path: 'history',
    data: {
      translationKey: 'auditHistory',
      transformer: UserChangeSetTransformer,
    },
    resolve: {
      context: OrganizationMemberHistoryResolver,
    },
    loadComponent: () => import('@markant-platform/shared/audit/feature').then(m => m.AuditOverviewComponent),
  },
];
